import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// import { Provider } from "react-redux";

import App from "./App";
// import store from "./redux/reducers/Index";

// import "bootstrap/dist/css/bootstrap.css";
import "./index.css";

const container = document.getElementById("root");
const root = createRoot(container!); // Non-null assertion because we know 'root' exists
root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
